import React from "react";
import { Col, Container, Row } from "reactstrap";
import LogoDark from "../../assets/images/logo-dark.svg";
import logoLight from "../../assets/images/logo-light.png";

const MultiTabRestrict: React.FC = () => {
  return (
    <div className="auth-page-content">
      <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
        <div className="auth-page-content overflow-hidden p-0">
          <Container>
            <Row className="justify-content-center">
              <Col xl={6}>
                <div className="card p-3 border card-border-light">
                  <div className="card-body text-center">
                    {/* Optional logo */}
                    {/* 
                    <img
                      src={logoLight}
                      className="mb-3"
                      alt="Logo"
                      height={40}
                    /> 
                    */}
                    <div className="mt-2">
                      <h4 className="fw-bold">Multiple Tab Restricted</h4>
                      <p className="mx-auto mb-0">
                        For security reasons, opening multiple tabs is not
                        allowed.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default MultiTabRestrict;
